<iframe  style="overflow: hidden;" [src]="pdfUrl | safe" [style.width.px]="screenWidth" [style.height.px]="screenHeight - 5" frameborder="0"></iframe>